// view.farrowing - released per-cycle farrowing records
//
// pig.farrowing.core owns all five render reads. Both persisted writes use the
// shared app_store writer with local optimistic state; scheduled maintenance
// publishes the derived webform mirrors from persisted source. Form state in
// PigContext is UI-only and does not depend on legacy boot data.

import type {MigratedSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: MigratedSurfaceDeclaration = Object.freeze({
  surface: 'view.farrowing',
  obligations: Object.freeze([Object.freeze({id: 'pig.farrowing.core', owner: 'permanent'})]),
  residualLegacy: Object.freeze([]),
});

export default declaration;
